import { render, staticRenderFns } from "./company-project-samples.vue?vue&type=template&id=442540cc&"
import script from "./company-project-samples.vue?vue&type=script&lang=js&"
export * from "./company-project-samples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports